import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  status: null, // VIP status for current listing
  loading: false,
  error: null,
  enrolling: false,
};

export const vipSlice = createSlice({
  name: 'vip',
  initialState,
  reducers: {
    setVipStatus: (state, action) => {
      state.status = action.payload;
      state.loading = false;
      state.error = null;
    },
    setVipLoading: (state, action) => {
      state.loading = action.payload;
    },
    setVipError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
      state.enrolling = false;
    },
    setVipEnrolling: (state, action) => {
      state.enrolling = action.payload;
    },
    clearVipStatus: (state) => {
      state.status = null;
      state.loading = false;
      state.error = null;
      state.enrolling = false;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setVipStatus,
  setVipLoading,
  setVipError,
  setVipEnrolling,
  clearVipStatus,
} = vipSlice.actions;

export default vipSlice.reducer;
